export default __webpack_public_path__ + "static/media/designer.db230cb3.png";